import React from "react";
import { useTheme, THEMES } from "@/context/ThemeContext";
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuLabel,
    DropdownMenuSeparator,
    DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { LanguageSwitcher } from "@/components/LanguageSwitcher";
import { Check } from "lucide-react";

export default function ThemeSwitcher({ compact = false, hideLanguage = false }) {
    const { theme, setTheme } = useTheme();
    const active = THEMES.find((t) => t.id === theme) || THEMES[0];
    const ActiveIcon = active.icon;

    return (
        <div className="inline-flex items-center gap-2">
            {!hideLanguage && <LanguageSwitcher />}
            <DropdownMenu modal={false}>
                <DropdownMenuTrigger asChild>
                    <Button
                        data-testid="theme-switcher-btn"
                        variant="outline"
                        size={compact ? "sm" : "default"}
                        className="rounded-md gap-2 border-border/70"
                        aria-label={`Theme: ${active.label} — change appearance`}
                    >
                        <ActiveIcon className="h-4 w-4" strokeWidth={1.5} />
                        {!compact && <span>{active.label}</span>}
                    </Button>
                </DropdownMenuTrigger>
                <DropdownMenuContent
                    align="end"
                    className="w-48 bg-popover border-border/70 z-50"
                    data-testid="theme-switcher-menu"
                >
                    <DropdownMenuLabel className="mono-label">Appearance</DropdownMenuLabel>
                    <DropdownMenuSeparator />
                    {THEMES.map((t) => {
                        const Icon = t.icon;
                        return (
                            <DropdownMenuItem
                                key={t.id}
                                data-testid={`theme-option-${t.id}`}
                                onClick={() => setTheme(t.id)}
                                className="flex items-center justify-between cursor-pointer"
                            >
                                <span className="inline-flex items-center gap-2">
                                    <Icon className="h-4 w-4" strokeWidth={1.5} />
                                    {t.label}
                                </span>
                                {t.id === theme && <Check className="h-4 w-4" strokeWidth={1.5} />}
                            </DropdownMenuItem>
                        );
                    })}
                </DropdownMenuContent>
            </DropdownMenu>
        </div>
    );
}
